import { RootState } from '@cp/src/store';
import { readQueryParams } from '@cp/src/utils/QueryParamsHelper';
import { useDispatch, useSelector } from 'react-redux';
import Loader from '@cp/src/components/Loader/Loader';
import IdCard from './IdCard';
import { EntityType, PENDING_APPROVALS_KEY, initialPaginationParams } from '../../constant';
import { approveOrRejectApproval } from '../../actions/ApprovalsActions';

const SelectedIdCard = () => {
  const approvalOrRejectionInProgress = useSelector(
    (state: RootState) => state.approvals.approvalOrRejectionInProgress
  );
  const selectedApprovalItem = useSelector(
    (state: RootState) => state.approvals.selectedIdApprovalItem
  );
  const { [PENDING_APPROVALS_KEY]: queryParams } = readQueryParams();

  const dispatch = useDispatch();

  const handleApproval = () => {
    if (selectedApprovalItem) {
      const payload = {
        approvalRequestId: selectedApprovalItem.referenceId,
        comment: '',
        approve: true
      };
      const params = queryParams
        ? { ...initialPaginationParams, ...queryParams }
        : initialPaginationParams;
      dispatch(approveOrRejectApproval(payload, { ...params, entityType: EntityType.AGENT_ID }));
    }
  };

  const handleRejection = (comment: string) => {
    if (selectedApprovalItem) {
      const payload = {
        approvalRequestId: selectedApprovalItem.referenceId,
        comment,
        approve: false
      };
      const params = queryParams
        ? { ...initialPaginationParams, ...queryParams }
        : initialPaginationParams;
      dispatch(approveOrRejectApproval(payload, { ...params, entityType: EntityType.AGENT_ID }));
    }
  };

  return (
    <>
      <IdCard handleApproval={handleApproval} handleRejection={handleRejection} />
      <Loader show={approvalOrRejectionInProgress} className={'overlay'} animate={false} />
    </>
  );
};

export default SelectedIdCard;
